import { useEffect, useRef, useState } from 'react';
import { Info } from 'lucide-react';

// Board / Senior-Management demo cohort login (2026-06-16).
//
// Gentle, transient "fall dead" notice. The shared write-suppression layer in
// services/api.js dispatches an 'alloggio:demo-view-only' window event whenever
// a write is short-circuited for a view-only demo session; this listens and
// shows a brief inline note so a clicked button reads as a no-op rather than a
// silent dead control or a scary error. No dependency — pure custom event.
export default function DemoViewOnlyToast() {
  const [message, setMessage] = useState('');
  const timerRef = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const onNotice = (e) => {
      const msg = (e && e.detail && e.detail.message) || 'View-only demo — changes are not saved.';
      setMessage(msg);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setMessage(''), 3200);
    };
    window.addEventListener('alloggio:demo-view-only', onNotice);
    return () => {
      window.removeEventListener('alloggio:demo-view-only', onNotice);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  if (!message) return null;

  return (
    <div style={styles.wrap} role="status" aria-live="polite">
      <div style={styles.toast}>
        <Info size={15} style={{ flexShrink: 0 }} />
        <span>{message}</span>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    position: 'fixed', bottom: '24px', left: 0, right: 0,
    display: 'flex', justifyContent: 'center', zIndex: 10000, pointerEvents: 'none', padding: '0 16px'
  },
  toast: {
    pointerEvents: 'auto',
    display: 'inline-flex', alignItems: 'center', gap: '8px',
    backgroundColor: 'var(--navy, #132139)', color: '#fff',
    borderRadius: '8px', padding: '10px 16px', fontSize: '13px', fontWeight: 500,
    boxShadow: '0 8px 24px rgba(0,0,0,0.28)', maxWidth: '90vw'
  }
};
